<template>
  <div class="container_box details_box_styles">
    <!--返回按钮-->
    <div class="go_back" @click="goBackBtn">
      <Icon class="back_icon" type="ios-arrow-back"/>
      <span class="back_txt">{{ $t('key1002627') }}</span>
    </div>
    <!--步骤条-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <h2 class="title_center">{{ $t('key1004420') + (detailsData.packageCode || '') }}</h2>
        <div class="steps_box">
          <Steps :current="currentStatus">
            <Step
              v-for="(item, index) in stepsList"
              :key="index"
              :title="item.title"
              :icon="item.icon"
              :content="item.time">
            </Step>
          </Steps>
        </div>
      </Card>
    </div>
    <!--主信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1004417') }}</h2>
        </template>
        <Row type="flex" :gutter="gutterItem">
          <Col :span="ItemCol" class="basic_item" v-for="(item, index) in masterInfoList" :key="index">
            <span class="basic_title">{{ item.name }}</span>
            <span class="basic_txt">{{ detailsData[item.paramsKey] || '-' }}</span>
          </Col>
        </Row>
      </Card>
    </div>
    <!--sku信息-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <div class="flex justify-content-between align-items-center">
            <h2 class="title_box">{{ $t('key1004430') }}</h2>
            <Select v-model="pageParams.type" transfer filterable style="width: 150px;" @on-change="changeType">
              <Option v-for="item in typeList" :key="item.value" :value="item.value">{{ item.title }}</Option>
            </Select>
          </div>
        </template>
        <div class="table_box">
          <Table
            highlight-row
            border
            max-height="520"
            :loading="tableLoading"
            :columns="tableColumns"
            :data="tableData">
          </Table>
          <Page
            :transfer="true"
            v-if="!tableLoading"
            :total="total"
            @on-change="changePage"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="changePageSize"
            placement="top"
            :page-size-opts="pageArray">
          </Page>
        </div>
      </Card>
    </div>
    <!--操作日志-->
    <div class="basic_information_box">
      <Card :bordered="false" dis-hover>
        <template #title>
          <h2 class="title_box">{{ $t('key1000288') }}</h2>
        </template>
        <Table
          highlight-row
          border
          max-height="450"
          :loading="tableLoading"
          :columns="operationLogColumns"
          :data="operationLogTableData">
        </Table>
      </Card>
    </div>
    <!--打印条码弹窗-->
    <printSkuBarcodeModal ref="printSkuBarcode"></printSkuBarcodeModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import {commonCopyContent, getAllUsersInfo, getDataSetBatchList, getUserNameByUserId, setConfigCharacters, getEnumList} from "@/utils/common";
import printSkuBarcodeModal from "@/views/supplier/components/supplierOrder/printSkuBarcodeModal";

export default {
  name: "stockOrderDetails",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      total: 0,
      pageParams: {
        packageId: this.$route.query.packageId,
        type: 1,
        pageNum: 1,
        pageSize: 15,
      },
      detailsData: {},
      currentStatus: 0,
      ItemCol: 6,
      stepsList: [],
      masterInfoList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004335'), paramsKey: 'packageCode'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004424'), paramsKey: 'outboundTypeText'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003352'), paramsKey: 'merchantName'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003353'), paramsKey: 'merchantId'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004158'), paramsKey: 'pickupOrderNumber'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001575'), paramsKey: 'shippingMethod'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001580'), paramsKey: 'expressageNo'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001180'), paramsKey: 'createdTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004425'), paramsKey: 'storageTime'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004159'), paramsKey: 'pickingEndTime'},
      ], // 主信息基础数据
      typeList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004426'), value: 1},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004427'), value: 2}
      ],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            if (params.row._productInfo) {
              let supplierSku = params.row._productInfo.sku || ''; // 供应商sku
              let ymsSku = params.row._productInfo.ymsSku || ''; // 云卖sku
              let productGoodsSpecifications = params.row._productInfo.productGoodsSpecifications || [];
              let spec = productGoodsSpecifications.map(i => i.name + '：' + i.value).join('、');
              let skuImgPath = params.row._productInfo.primaryImage;
              let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
              let imgPath = skuImgPath ? skuImgPath : spuImgPath;
              let list = [
                v.tableImg(h, params, null, imgPath),
                h('div', {
                  class: 'text-align-left pl10'
                }, [
                  h('Alink', {
                    props: {
                      linkName: params.row._productInfo._spuInfo.name,
                      textAlign: 'left',
                      className: 'mb5',
                      AlinkClass: 'ellipsis_1',
                      AlinkShow: true
                    },
                    on: {
                      AlinkBtn: () => {
                        const {href} = v.$router.resolve({
                          path: '/productDetails',
                          query: {
                            type: 'look',
                            productId: params.row.productGoodsId
                          }
                        });
                        window.open(href, '_blank');
                      }
                    }
                  }),
                  h('p', {class: 'flex align-items-center mb5'}, [
                    h('span', {style: {color: '#000'}}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003976') + supplierSku),
                    supplierSku ? h('Icon', {
                      props: {
                        type: 'ios-copy-outline',
                        size: 18,
                        color: '#01a6ee'
                      },
                      style: {
                        marginLeft: '10px',
                        cursor: 'pointer'
                      },
                      attrs: {
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                      },
                      on: {
                        click: () => {
                          commonCopyContent(supplierSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                        }
                      }
                    }) : ''
                  ]),
                  h('p', {class: 'flex align-items-center mb5'}, [
                    h('span', {style: {color: '#000'}}, `${setConfigCharacters(false)}SKU：` + ymsSku),
                    ymsSku ? h('Icon', {
                      props: {
                        type: 'ios-copy-outline',
                        size: 18,
                        color: '#01a6ee'
                      },
                      style: {
                        marginLeft: '10px',
                        cursor: 'pointer'
                      },
                      attrs: {
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                      },
                      on: {
                        click: () => {
                          commonCopyContent(ymsSku, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000002'));
                        }
                      }
                    }) : ''
                  ]),
                  h('div', {class: 'flex align-items-center'}, [
                    h('p', {
                      style: {
                        width: '70px',
                        textAlign: 'right'
                      }
                    }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000240')),
                    h('p', {
                      style: {
                        flex: 1
                      },
                      class: 'color-green'
                    }, spec),
                  ])
                ])
              ];
              return h('div', {
                class: 'flex ptb10',
              }, list);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004428'),
          minWidth: 130,
          key: 'quantity',
          align: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004429'),
          minWidth: 130,
          key: 'actualSortingNumber',
          align: 'left',
          render(h, params) {
            let quantity = params.row.quantity || 0;
            let actualSortingNumber = params.row.actualSortingNumber || 0;
            let talg = quantity !== actualSortingNumber;
            let pickingEndTime = v.detailsData.pickingEndTime;
            if (pickingEndTime) {
              return h('Alink', {
                props: {
                  linkName: actualSortingNumber,
                  textAlign: 'left',
                  AlinkShow: false,
                  styles: {
                    color: talg ? '#D9001B' : ''
                  }
                },
              });
            } else {
              return h('span', '-');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          width: 100,
          key: 'options',
          align: 'left',
          render(h, params) {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
                    show: true,
                    clickFn: () => {
                      if (v.detailsData.outboundType === 2) {
                        v.$refs['printSkuBarcode'].initPrintSkuBarcodeData(params.row);
                      } else {
                        v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006848')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006849')}`);
                        return false;
                      }
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      operationLogColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000290'),
          key: 'logContentDesc',
          minWidth: 400,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000291'),
          key: 'updatedTime',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', v.$uDate.getDataToLocalTime(params.row.updatedTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        }
      ],
      operationLogTableData: [],
      pageParamsStatus: false,
      userInfoList: {},
      enumData: [],
    };
  },
  computed: {
    // 出库单类型
    deliveryOrderTypeList() {
      const ENUM_KEY = 'PackageInfoOutboundTypeSupplierEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list = list.filter(item => [2, 3, 4].includes(item.value));
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      let packageId = this.$route.query.packageId;
      (async () => {
        let enumKeyList = ['PackageInfoOutboundTypeSupplierEnum'];
        this.enumData = await getDataSetBatchList(enumKeyList);

        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getDetailsData(packageId);
        await v.getSkuInfoData();
      })();
    },
    // 返回列表
    goBackBtn() {
      this.$router.push('/stockList');
    },
    // 获取详情数据
    getDetailsData(packageId) {
      let v = this;
      v.axios.get(api.get_packageInfo_stock + packageId, {loading: true}).then((response) => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let timerKeyList = ['createdTime', 'pickingEndTime', 'despatchTime', 'storageTime'];
            timerKeyList.map((key) => {
              data[key] = data[key] ? v.$uDate.dealTime(data[key], 'fulltime') : '';
            });
            v.deliveryOrderTypeList.map((item) => {
              if (item.value === data.outboundType) {
                data.outboundTypeText = item.title;
              }
            });

            v.stepsList = [
              {status: 0, icon: 'md-cash', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001799'), time: data.createdTime},
              {status: 1, icon: 'md-car', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004327'), time: data.despatchTime},
              {status: 2, icon: 'md-cube', title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004557')}`, time: data.pickingEndTime}
            ];
            v.stepsList.map((item) => {
              if (item.time) {
                v.currentStatus = item.status;
              }
            });
            v.operationLogTableData = data.logList || [];
            v.detailsData = data;
          }
        }
      });
    },
    // 获取sku信息列表数据
    getSkuInfoData() {
      let v = this;
      v.tableData = [];
      v.axios.post(api.post_packageInfo_queryPackageGoodsById, v.pageParams).then((response) => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let list = data.list || [];
            if (list.length > 0) {
              let productGoodsIds = [];
              list.map((item) => {
                productGoodsIds.push(item.productGoodsId);
              });
              if (productGoodsIds.length > 0) {
                (async () => {
                  this.tableData = await this.getProductInfoByIds(productGoodsIds, list, false,
                    false, false, api.post_productInfo_queryByProductGoodsIds, 'supplier');
                })();
              } else {
                v.tableData = list;
              }
            }
            v.total = data.total;
          }
        }
      });
    },
    // 切换筛选
    changeType() {
      this.getSkuInfoData();
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getSkuInfoData();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    printSkuBarcodeModal
  }
};
</script>

<style lang="less" scoped>
.details_box_styles {
  .basic_information_box {
    .steps_box {
      width: 60%;
    }
  }
}
</style>
